import axios from 'axios'
import router from '@/router'
import store from '@/store/store'

const instance = axios.create()

instance.defaults.baseURL = process.env.VUE_APP_API;
instance.defaults.headers.get['Accept'] = 'application/json';
instance.defaults.headers.get['Content-Type'] = 'application/json';

if (localStorage.getItem('token')) {
  instance.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('token');
}

instance.interceptors.request.use(function (config) {
    const currentLocation = router.currentRoute.name
    // Do something before request is sent
    if(currentLocation !== 'chat') {
        store.commit('set_spinner', true)
    }
    return config;
},  function (error) {
    // Do something with request error
    return Promise.reject(error);
});

instance.interceptors.response.use(function(response) {
    store.commit('set_spinner', false)
    return response
}, function(error) {
  store.commit('set_spinner', false);
    if (error.response.status === 401) {
        store.dispatch('logout');
        router.push('/login');
    }
    if (error.response.status === 500) {
        router.push('/500');
    }
    return Promise.reject(error);
})

export default instance